import crypto from 'crypto-es';
export function isObject(obj) {
    return obj != null && Object.getPrototypeOf(obj).isPrototypeOf(Object) && typeof obj === 'object';
}
export const isValidSHA256String = (value) => typeof value === 'string' && /^[a-f0-9]{64}$/gi.test(value);
export function digestMessage(message) {
    const inputArray = crypto.enc.Utf8.parse(message); // encode as UTF-8
    // eslint-disable-next-line new-cap
    const digestArray = crypto.SHA256(inputArray); // hash the message
    return crypto.enc.Hex.stringify(digestArray); // convert digest to string
}
